import { render } from "./IndexPage.vue?vue&type=template&id=aaa98b2e"
import script from "./IndexPage.vue?vue&type=script&lang=js"
export * from "./IndexPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__